import {whitelist} from 'store/config/reducer';

export const VWRAP_KMC_KEY = 'cielo24VWRAP';

const isValid = value => (value !== undefined && value !== null && value !== '');

const legacy = {
    domContainer: {key: 'cielo24Transcriptions.DynaTransTargetDivId'},
    transcriptVisible: {key: 'cielo24Transcriptions.DynaTranscriptStartsHidden', negate: true},
    downloadEnabled: {key: 'cielo24Transcriptions.DynaTransHideDownload', negate: true},
    printEnabled: {key: 'cielo24Transcriptions.DynaTransHidePrint', negate: true},
    shareEnabled: {key: 'cielo24Transcriptions.DynaTransHideShare', negate: true},
    speakersVisible: {key: 'cielo24Transcriptions.DynaTransHideSpeakers', negate: true},
    searchVariable: {key: 'cielo24Transcriptions.DynaTransSearchVar'},
    clientLogoImage: {key: 'cielo24Transcriptions.DynaTransClientLogo'},
    clientLogoHref: {key: 'cielo24Transcriptions.DynaTransClientHref'},
    sponsorLogoImage: {key: 'cielo24Transcriptions.DynaTransSponsorLogo'},
    sponsorLogoHref: {key: 'cielo24Transcriptions.DynaTransSponsorHref'},
};

export const evaluate = (kdp, source, negate) => {
    const value = kdp.evaluate(`{${source}}`);
    if (isValid(value)) return (negate ? !value : value);
};

export const parseOptions = kdp => whitelist.reduce((options, option) => {
    let value = evaluate(kdp, `${VWRAP_KMC_KEY}.${option}`);
    if (!isValid(value) && legacy[option]) value = evaluate(kdp, legacy[option].key, legacy[option].negate);
    if (isValid(value)) options[option] = value;
    return options;
}, {});



// WEBPACK FOOTER //
// ./scripts/adapters/kaltura/options.js